// import JobAdGenerator from '../components/JobAdGenerator';
import { ReactElement } from 'react';
import { DefaultScreen, SignIn } from 'pages';
import ModelTrainer from 'pages/modelTrainer';
import NotFound from 'components/NotFound';

export interface RouteType {
    path: string;
    element: ReactElement;
    children?: RouteType[];
}

export const PROTECTED_ROUTES: RouteType[] = [
    {
        path: '/',
        element: <DefaultScreen />,
    },
    {
        path: '/job/:document_id',
        element: <DefaultScreen />,
    },
    {
        path: '/model-trainer/:collection_id',
        element: <ModelTrainer />,
    },
    // @DEPRECATED: Auth whitelisting removed
    // {
    //     path: '/users',
    //     element: <ControllUsers />,
    // },
];

export const PUBLIC_ROUTES: RouteType[] = [
    {
        path: 'sign-in',
        element: <SignIn />,
    },
];

export const NOT_FOUND: RouteType[] = [
    {
        path: '*',
        element: <NotFound />,
    },
];
